import React, { useContext, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { AnswerContext } from "../../index";
import { Suggestion } from "../../../../Theme";
// import { Container } from './styles';

function StepTwo() {
  const { state, dispatch, WizardContext } = useContext(AnswerContext);
  const { dispatch: wizardDispatch } = useContext(WizardContext);
  const isMobile = useMediaQuery("(max-width:426px)");

  function handleChange(event) {
    dispatch({ type: "UPDATE_NAME", name: event.target.value });
  }

  useEffect(() => {
    wizardDispatch({
      type: "SET_IS_COMPLETE",
      isComplete: state.name ? true : false,
    });
  }, [state]);

  function handleKeyUp(event) {
    if (event.key === "Enter") {
      if (state.nameShow) wizardDispatch({ type: "NEXT_STEP" });
    }
  }
  function getTextField(autoFocus) {
    return (
      <TextField
        autoFocus={autoFocus}
        placeholder="Ex: Ingrediente"
        value={state.name}
        fullWidth
        label="Descrição"
        variant="outlined"
        onChange={handleChange}
        onKeyUp={handleKeyUp}
      />
    );
  }

  return (
    <div>
      {isMobile && getTextField(false)}
      {!isMobile && getTextField(true)}
      <Suggestion>Pressione [Enter] para avançar</Suggestion>
    </div>
  );
}

export default StepTwo;
